export default __webpack_public_path__ + "static/media/registro.93230f6b.png";